document.addEventListener("DOMContentLoaded", function() {
    const hiddenInput = document.querySelector('input[name="id"]');
    
    function handleInputChange() {
        const variantIdFromInput = hiddenInput.value;
        const elementsWithVariantId = document.querySelectorAll('[variant-description-id="' + variantIdFromInput + '"]');
        const elementVariant = document.querySelectorAll('.variant_description');
       
        elementVariant.forEach(function(element) {
            element.classList.remove('active');
        });
        
        elementsWithVariantId.forEach(function(element) {
            element.classList.add('active');
        });
    }
    
    hiddenInput.addEventListener('change', handleInputChange);
    
    handleInputChange();
});